import { connect } from 'react-redux';
import MInproductionPage from './MInproductionPage';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import { rowClick, downloadURL, onbulkDownload, approvalRequired, onBulkDownloadStl } from 'src/actions/completeOrderAction';
import { RowDataCompleted } from 'src/reducers/completeorderfile';
import { rework } from 'src/actions/liveOrderAction';
import { doCheckAuthentication } from 'src/actions/aunthenticateAction';
import { getMInproductionOrderData } from 'src/actions/manufacturAction';
import { openVideoPlayerURLArray } from 'src/actions/landingPageAction';
// import { push } from 'react-router-redux';
// import {
//     saveFeedbackType,
//     saveCommands,
//     doFeedback
// } from '../../actions/feedbackAction';

export const mapStateToProps = (state: AppState) => {
    return {
        mInproductionData: state.manufactur.mInproductionOrderData,
        isDownloading: state.completeOrder.isDownloading,
        redesignReasons: state.completeOrder.redesignReasons,
        orderDataTat: state.fileUpload.orderDataTat
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onComponentDidMount: () => {
            // dispatch(getRedesignReasons);
        },
        onComponentWillMount: () => {
            dispatch(doCheckAuthentication);
            dispatch(getMInproductionOrderData);
        },
        reload: () => {
            dispatch(getMInproductionOrderData);
        },
        onRowClick: (orderid: string, rowData: string) => {
            dispatch(rowClick(orderid, rowData));
        },
        onDownloadClick: (filepath: string, fileName: string) => {
            dispatch(downloadURL(filepath, fileName, 'Final Scan'));
        },
        onBulkDownload: (completedData: RowDataCompleted[] | RowDataCompleted) => {
            dispatch(onbulkDownload(completedData, true));
        },
        onBulkDownloadStl: (completedData: RowDataCompleted[] | RowDataCompleted, filetype: string) => {
            dispatch(onBulkDownloadStl(completedData, filetype, true));
        },
        approvalRequired: (array: Array<object>) => {
            dispatch(approvalRequired(array));
        },
        redesignRequest: (columns: Object) => {
            dispatch(rework(columns, 'minproduction'));
        },
        dateFilter: () => {
            dispatch(getMInproductionOrderData);
        },
        dateReset: () => {
            dispatch(getMInproductionOrderData);
        },
        openVideoPlayerURL: (fullPath: string[], fpath: string) => {
            dispatch(openVideoPlayerURLArray(fullPath, fpath));
        },
        caseFilter: (fcaseno: string, tcaseno: string, status: string) => {
            // dispatch(getMInproductionOrderDataFilter(fcaseno, tcaseno, status));
        }
    };
};

const MInproductionContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(MInproductionPage);

export default MInproductionContainer;



// WEBPACK FOOTER //
// ./src/components/MInproduction/MInproductionContainer.tsx